import { Component, OnInit, Input } from '@angular/core';
import { IPeerInfo } from 'src/app/store/samwin/samwin-lines/samwin-lines.state';

@Component({
   selector: 'samweb-peer-info',
   templateUrl: './peer-info.component.html',
   styleUrls: ['./peer-info.component.scss'],
})
export class PeerInfoComponent implements OnInit {
   @Input()
   public call: IPeerInfo;

   constructor() {}

   ngOnInit(): void {}
}
